module.exports = __webpack_public_path__ + "img/icon-catalogo-libros.6251a3d1.svg";